import {
  makeStyles,
  Container,
  Grid,
  Typography, Button
} from '@material-ui/core';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import {useAppStateContext} from "../../../AppStateProvider/AppStateProvider";
import Error from "./img-error.svg";

const useStyles = makeStyles({
  paper: {
    padding: '1.5em',
    borderRadius: '8px',
    width: '388px',
  },
  paperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  copyButton: {
    borderLeft: 'solid 1px #E1E3EA',
    maxHeight: '2.5em',
    display: 'flex',
  },
  errorIcon: {
    position: 'absolute',
    right: 'calc(100% + 18px)',
    '@media screen and (max-width: 950px)': {
      display: 'none'
    }
  },
  caption: {
    marginTop: '1.3em',
  },
  illustrationContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media screen and (max-width: 950px)': {
      justifyContent: 'center'
    }
  },
  image: {
    width: '245px',
    height: '320px',
    '@media screen and (max-width: 761px)': {
      marginTop: '12px',
      width: '30vh',
      height: 'auto',
      maxWidth: '100%'
    }
  },
  gridContainer: {
    justifyContent: "space-between",
    alignItems:"center",
    '@media screen and (max-width: 950px) and (min-width: 761px)': {
      display: 'flex',
      flexWrap: 'nowrap'
    },
    '@media screen and (max-width: 760px)': {
      justifyContent: 'center'
    },
  },
});

export function UnsupportedBrowser() {
  const classes = useStyles();
  const { nextPane } = useAppStateContext();

  return (
    <>
      <Container>
        <Grid container className={classes.gridContainer}>
          <Grid item md={5}>
            <Typography variant="h1" gutterBottom style={{ position: 'relative' }}>
              <div className={classes.errorIcon}>
                <ErrorIcon />
              </div>{' '}
              Your browser is not supported
            </Typography>
            <Typography variant="body1" gutterBottom>
              Net2phone is optimized to work with Chrome browser. The browser you are using may have display issues.
            </Typography>
            <Button color="primary" disableRipple onClick={nextPane}>
              Skip for now
            </Button>
          </Grid>
          <Grid item md={5} className={classes.illustrationContainer}>
            <img src={Error} alt="Error" className={classes.image} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
